<template>
    <div>
      <!-- Фильтры -->
      <v-card class="ma-2">
        <v-card-title><T>Фильтры</T></v-card-title>
        <v-card-text>
          <div style="width: 100%;" class="d-flex">
            <DateFilter :minusDaysForStartDate="7" ref="dateFilter" />
            <v-btn class="mx-2" fab dark color="success" @click="updateData">
              <v-icon dark>mdi-autorenew</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
  
      <div v-if="loading">
        <v-card>
          <div style="width: 100%;" class="d-flex justify-center py-8">
            <v-progress-circular color="success" indeterminate></v-progress-circular>
          </div>
        </v-card>
      </div>

      <div v-else>
        <!-- Блок "Выручка" -->
        <v-card class="ma-2">
          <v-card-title><T>Выручка</T></v-card-title>
          <v-card-text>
            <v-row style="align-items: center; justify-content: space-evenly;">
              <div style="width: 450px;">
                <apexchart
                  type="pie"
                  :options="optionsCircleRevenue"
                  :series="seriesCircleRevenue"
                ></apexchart>
              </div>
              <div style="width: 650px;">
                <apexchart
                  type="line"
                  :options="optionsLineRevenue"
                  :series="seriesLineRevenue"
                ></apexchart>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
    
        <!-- Блок "Количество заказов" -->
        <v-card class="ma-2">
          <v-card-title><T>Количество заказов</T></v-card-title>
          <v-card-text>
            <v-row style="align-items: center; justify-content: space-evenly;">
              <div style="width: 450px;">
                <apexchart
                  type="pie"
                  :options="optionsCircleOrderQuantity"
                  :series="seriesCircleOrderQuantity"
                ></apexchart>
              </div>
              <div style="width: 650px;">
                <apexchart
                  type="line"
                  :options="optionsLineOrderQuantity"
                  :series="seriesLineOrderQuantity"
                ></apexchart>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
    
        <!-- <v-card class="ma-2">
          <v-card-title>Типы заказа</v-card-title>
          <v-card-text>
          </v-card-text>
        </v-card>
    
        <v-card class="ma-2">
          <v-card-title>Источники заказа</v-card-title>
          <v-card-text>
          </v-card-text>
        </v-card> -->
      </div>
    </div>
  </template>
  
  <script>
  import DateFilter from '../../components/orders/DateFilter.vue';
  
  export default {
    name: "dashboard",
    components: { DateFilter },
    data() {
      return {
        loading: false,
        dateBegin: null,
        dateEnd: null,
  
        // Круговая диаграмма: распределение выручки по типам валют (Рубли, Кредитки)
        seriesCircleRevenue: [],
        optionsCircleRevenue: {
          chart: {
            width: '100%',
            height: '100%',
            type: 'pie',
          },
          // Подписи для pie: два сегмента
          labels: ['Наличные', 'Картой', 'Онлайн'],
          dataLabels: { enabled: false },
          legend: { show: true, position: 'right' },
          tooltip: {
            enabled: true,
            custom: ({ seriesIndex }) => {
              const value = this.seriesCircleRevenue[seriesIndex];
              const total = this.seriesCircleRevenue.reduce((a, b) => a + b, 0);
              const percentage = ((value / total) * 100).toFixed(2);
              const label = this.optionsCircleRevenue.labels[seriesIndex];
              return `
                <div class="d-flex flex-column pa-2">
                  <p style="margin-bottom: 0px;">${label}</p>
                  <p style="margin-bottom: 0px;">В процентах: ${percentage}%</p>
                  <p style="margin-bottom: 0px;">Абсолютное значение: ${value}</p>
                </div>
              `;
            }
          }
        },
  
        // Линейный график: динамика выручки по датам
        seriesLineRevenue: [],
        optionsLineRevenue: {
          chart: { height: 350, type: 'line', zoom: { enabled: false } },
          dataLabels: { enabled: false },
          stroke: { curve: 'straight' },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            },
          },
          xaxis: { categories: [] },
          legend: { show: true, position: 'right' },
        },
  
        // Круговая диаграмма: распределение заказов по зонам
        seriesCircleOrderQuantity: [],
        optionsCircleOrderQuantity: {
          chart: { width: '100%', height: '100%', type: 'pie' },
          labels: [], // Подписи будут вида "Зона 0", "Зона 1" и т.д.
          dataLabels: { enabled: false },
          legend: { show: true, position: 'right' },
          tooltip: {
            enabled: true,
            custom: ({ seriesIndex }) => {
              const value = this.seriesCircleOrderQuantity[seriesIndex];
              const total = this.seriesCircleOrderQuantity.reduce((a, b) => a + b, 0);
              const percentage = ((value / total) * 100).toFixed(2);
              const label = this.optionsCircleOrderQuantity.labels[seriesIndex];
              return `
                <div class="d-flex flex-column pa-2">
                  <p style="margin-bottom: 0px;">${label}</p>
                  <p style="margin-bottom: 0px;">В процентах: ${percentage}%</p>
                  <p style="margin-bottom: 0px;">Абсолютное значение: ${value}</p>
                </div>
              `;
            }
          }
        },
  
        // Линейный график: динамика заказов по датам (по зонам + ИТОГО)
        seriesLineOrderQuantity: [],
        optionsLineOrderQuantity: {
          chart: { height: 350, type: 'line', zoom: { enabled: false } },
          dataLabels: { enabled: false },
          stroke: { curve: 'straight' },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            },
          },
          xaxis: { type: 'category', categories: [] },
          legend: { show: true, position: 'right' },
        },
      }
    },
  
    async mounted() {
      this.loading = true;
      await this.loadCashReportInfo();
      await this.loadOrderQuantityData();
      this.loading = false;
    },
  
    methods: {
      async updateData() {
        // Обновляем обе секции
        this.loading = true;
        await this.loadCashReportInfo();
        await this.loadOrderQuantityData();
        this.loading = false;
      },
  
      /* Метод загрузки данных выручки */
      async loadCashReportInfo() {
        // Получаем даты из фильтра
        this.dateBegin = await this.$refs.dateFilter.getDateBegin();
        this.dateEnd = await this.$refs.dateFilter.getDateEnd();
  
        const cashData = await this.$store.dispatch('getCashReportInfo', { 
          date_begin: this.dateBegin, 
          date_end: this.dateEnd 
        });
        
        // Для pie используем строку с датой "ИТОГО"
        const totalRow = cashData.find(row => row.date === "ИТОГО");
        if (totalRow) {
          // Отображаем только Рубли и Кредитки
          this.seriesCircleRevenue = [totalRow.cash, totalRow.card, totalRow.online];
        }
        
        // Для line графика исключаем строку "ИТОГО"
        const lineData = cashData.filter(row => row.date !== "ИТОГО");
        
        this.seriesLineRevenue = [
          {
            name: "Наличные",
            data: lineData.map(row => row.cash)
          },
          {
            name: "Картой",
            data: lineData.map(row => row.card)
          },
          {
            name: "Онлайн",
            data: lineData.map(row => row.online)
          },
          {
            name: "ИТОГО",
            data: lineData.map(row => row.total)
          }
        ];
        
        // Формируем подписи для оси X (формат dd.mm)
        let arr = [];
        lineData.forEach(row => {
          const formattedDate = this.formatDate(row.date);
          arr.push(formattedDate);
        });
        this.optionsLineRevenue.xaxis.categories = arr;
      },
  
      /* Метод загрузки данных по количеству заказов */
      async loadOrderQuantityData() {
        const rawData = await this.$store.dispatch('getZonesDataTableInfo', {
          date_begin: this.dateBegin,
          date_end: this.dateEnd
        });
  
        // --- Формирование данных для круговой диаграммы ---
        // Суммируем заказы по каждой зоне за весь период
        const zoneTotals = {};
        rawData.forEach(item => {
          const zone = item.delivery_zone;
          zoneTotals[zone] = (zoneTotals[zone] || 0) + item.count;
        });
  
        // Список зон, отсортированный по ключу (например, "0", "1", ...)
        const zonesArray = Object.keys(zoneTotals).sort();
        // Подписи для pie: "Зона 0", "Зона 1", ...
        this.optionsCircleOrderQuantity.labels = zonesArray.map(z => `Зона "${this.$store.getters.local_refs.geocoding.zones[z].name}"`);
        // Значения для pie
        this.seriesCircleOrderQuantity = zonesArray.map(z => zoneTotals[z]);
  
        // --- Формирование данных для линейного графика ---
        // Собираем все уникальные даты
        const dateSet = new Set();
        rawData.forEach(item => dateSet.add(item.date));
        const allDates = Array.from(dateSet).sort((d1, d2) => new Date(d1) - new Date(d2));
  
        // Создаём карту: dataMap[date][zone] = count
        const dataMap = {};
        rawData.forEach(item => {
          const d = item.date;
          const z = item.delivery_zone;
          if (!dataMap[d]) {
            dataMap[d] = {};
          }
          dataMap[d][z] = (dataMap[d][z] || 0) + item.count;
        });
  
        // Формируем серии для каждой зоны
        const zoneSeries = zonesArray.map(zone => {
          const dataForZone = allDates.map(date => dataMap[date]?.[zone] || 0);
          return {
            name: `Зона "${this.$store.getters.local_refs.geocoding.zones[zone].name}"`,
            data: dataForZone
          };
        });
  
        // Дополнительно вычисляем серию "ИТОГО" по дате (сумма по всем зонам)
        const totalSeries = {
          name: "ИТОГО",
          data: allDates.map(date => {
            const counts = dataMap[date] ? Object.values(dataMap[date]) : [0];
            return counts.reduce((sum, cur) => sum + cur, 0);
          })
        };
  
        this.seriesLineOrderQuantity = [...zoneSeries, totalSeries];
  
        // Формируем подписи оси X (формат dd.mm)
        this.optionsLineOrderQuantity.xaxis.categories = allDates.map(d => {
            const dateObj = new Date(d);
            if (isNaN(dateObj.getTime())) return d;
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            return `${day}.${month}`;
        });
      },

      formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        // const year = date.getFullYear();
        return `${day}.${month}`;
      }
    }
  }
  </script>